<script setup lang="ts">
import { useLoadingStore } from '@/stores/loading';

const loadingStore = useLoadingStore();

</script>

<template>

    <div v-if="loadingStore.isLoading" class="load-box">
        <div class="spinner"></div>
    </div>

</template>

<style lang="scss" scoped>
.load-box {
    position: fixed;
    top: 50%;
    left: 50%;

    .spinner {
        width: 30px;
        height: 30px;
        border: 4px solid #ccc;
        border-top-color: var(--color-sf-primary);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>